module.exports = __webpack_public_path__ + "img/waggle-logo.dark.d60215aa.svg";